export default "__VITE_ASSET__87f0a51f__"